import React from 'react';
import PackModal from './PackModal';
import EuroModal from './EuroModal';
import SignatureModal from './SignatureModal';
import SubscribeModal from './SubscribeModal/SubscribeModal';
import NowEModal from './NowEModal';


interface GetStartedModalsProps {
}

const GetStartedModals: React.FC<GetStartedModalsProps> = () => {
    return (
        <>
        <PackModal />
        <EuroModal />
        <SignatureModal />
        <SubscribeModal />
        <NowEModal/>
        </>
    );
};

export default GetStartedModals;